import { render, staticRenderFns } from "./CommercialPolicyForm.vue?vue&type=template&id=510c103c"
import script from "./CommercialPolicyForm.vue?vue&type=script&lang=js"
export * from "./CommercialPolicyForm.vue?vue&type=script&lang=js"
import style0 from "./CommercialPolicyForm.vue?vue&type=style&index=0&id=510c103c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports